// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".payment-system-list[data-v-51f37050]{display:flex}.payment-system-list .payment-system-item[data-v-51f37050]:not(:last-child){margin-right:20px}.payment-system-list_new .payment-system-item[data-v-51f37050]{background:#fff}.payment-system-list_old .payment-system-item[data-v-51f37050]{background:#1f1f1f}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
